import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureTableHeaderCellContent = ({
  ProductDisplayName,
  Price,
  PurchaseMotion
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: ProductDisplayName
    }), /*#__PURE__*/_jsx(View, {
      children: Price
    }), /*#__PURE__*/_jsx(View, {
      children: PurchaseMotion
    })]
  });
};